'use strict';

var log = require('../../log/Log').channel('RemoteControlCodeController');
var QRCode = require('qrcode-svg');
require('./RemoteControlService');

angular.module('inara')
.directive('remoteControlCode', function() {
    return {
        restrict: 'E',
        scope: {},
        templateUrl: 'remoteControlCode.html',
        controllerAs: 'vm',
        controller: RemoteControlCodeContoller
    };
});

RemoteControlCodeContoller.$inject = ['$scope', 'RemoteControlService',
    'gettextCatalog', '$sce', '$window', '$timeout', '$document'];

function RemoteControlCodeContoller($scope, RemoteControlService,
    gettextCatalog, $sce, $window, $timeout, $document) {
    var vm = this;
    vm.getQrCode = getQrCode;
    vm.getRemoteCode = RemoteControlService.getRemoteControlCode;
    vm.getRemoteControlQrInstructions = getRemoteControlQrInstructions;
    vm.getRemoteControlUrlInstructions = getRemoteControlUrlInstructions;
    vm.remoteControlCodeVisible = RemoteControlService.remoteControlCodeVisible;
    var qrCodeSvgString = null;
    var qrCodeData = null;
    var remoteControlInstructions = null;
    var translatedRemoteControlInstructions = null;

    log.info('initializing');

    // Font size for the app is used to determine scale factor, which we need
    // to size the QR code
    var baseFontSize = 16;
    var fontSize = baseFontSize;
    updateFontSize();

    $window.addEventListener('resize', onWindowResize);

    $scope.$on('$destroy', function() {
        $window.removeEventListener('resize', onWindowResize);
    });

    function getQrCode() {
        if (RemoteControlService.getRemoteControlCode() === null ||
            RemoteControlService.getRemoteControlUrl() === null) {
            return $sce.trustAsHtml('');
        }
        var newQrCodeData = RemoteControlService.getRemoteControlUrl();
        if (qrCodeSvgString === null || qrCodeData !== newQrCodeData) {
            qrCodeData = newQrCodeData;
            qrCodeSvgString = new QRCode({
                content: qrCodeData,
                width: Math.round(150 * fontSize / baseFontSize),
                height: Math.round(150 * fontSize / baseFontSize),
                padding: 0,
                background: 'none',
                join: true
            }).svg();
        }
        return $sce.trustAsHtml(qrCodeSvgString);
    }

    function getRemoteControlQrInstructions() {
        /// Instructions for room remote control via scanning a QR code (part 1/2)
        return gettextCatalog.getString('Scan the QR code');
    }

    function getRemoteControlUrlInstructions() {
       var remoteControlUrl = 'www.miraconnect.me';
        /// Instructions for room remote control via code entry on a web page 
        /// (part 2/2, followed by code)
       var translated = gettextCatalog.getString(
            'or go to {{remoteControlUrl}} and enter',
            { remoteControlUrl: remoteControlUrl });

       if (translatedRemoteControlInstructions !== translated) {
           translatedRemoteControlInstructions = translated;
           // dynamically insert span elements so we can format the URL with CSS
           var interpolationRegex =
               new RegExp('(.*)(' + remoteControlUrl.replace(/\./g, '\\.') + ')(.*)');
           var matches = translated.match(interpolationRegex);
           if (matches && matches.length > 3) {
               remoteControlInstructions = $sce.trustAsHtml(
                   (matches[1].length > 0 ? '<p>' + matches[1] + '</p>' : '') +
                   '<span class="remote-url">' + matches[2] + '</span>' +
                   (matches[3].length > 0 ? '<p>' + matches[3] + '</p>' : ''));
           } else {
               // fall back to unformatted string if we couldn't match it
               remoteControlInstructions = $sce.trustAsHtml(
                   '<p>' + translated + '</p>');
           }
       }

       return remoteControlInstructions;
    }

    function onWindowResize() {
        $timeout(function() {
            // reset the QR code SVG when the window resizes so we can scale it
            updateFontSize();
            qrCodeSvgString = null;
        });
    }

    function updateFontSize() {
        var html = $document[0].querySelectorAll('html');
        var style = html.length > 0 ? $window.getComputedStyle(html[0]) : null;
        var fontMatch = style ? style.fontSize.match(/\d*(\.\d+)?/) : null; 
        if (fontMatch) {
            fontSize = parseFloat(fontMatch[0]);
        } else {
            fontSize = baseFontSize;
        }
    }
}

module.exports = RemoteControlCodeContoller;